import Login from "../Pages/auth/Login";
import {
  BadlaInstrument,
  BadlaSetting,
  Dashboard,
  DollerRate,
  Exchange,
  Import,
  Instrument,
} from "../Pages";
import ImportFilterList from "../Pages/ImportFilterList";
import ExpireInstrument from "../Pages/ExpireInstrument";

export const authRouter = [
  {
    path: "/",
    component: Dashboard,
    exact: true,
  },
  {
    path: "/import",
    component: Import,
    exact: true,
  },
  {
    path: "/import/filter",
    component: ImportFilterList,
    exact: true,
  },
  {
    path: "/import/expireInstrument",
    component: ExpireInstrument,
    exact: true,
  },
  {
    path: "/instrument",
    component: Instrument,
    exact: true,
  },
  {
    path: "/exchange",
    component: Exchange,
    exact: true,
  },
  {
    path: "/badla/instrument",
    component: BadlaInstrument,
    exact: true,
  },

  {
    path: "/badla/setting",
    component: BadlaSetting,
    exact: true,
  },
  {
    path: "/dollar/rate",
    component: DollerRate,
    exact: true,
  },
];

export const publicRouter = [
  {
    path: "/login",
    component: Login,
  },
];
